import { Injectable } from '@angular/core';
import { SnackService } from '@shared/services/snack.service';
import { ConfirmationResult, RecaptchaVerifier, UserCredential, getAuth, signInWithPhoneNumber } from 'firebase/auth';

@Injectable({
	providedIn: 'root',
})
export class FirebaseService {
	constructor(private readonly snackService: SnackService) {}

	private confirmationResult: ConfirmationResult;

	/**
	 * Request that Firebase send an authentication code to the user's phone by SMS
	 *
	 * @param phoneNumber User's phone number
	 * @returns { ConfirmationResult } A result from a phone number sign-in, link, or reauthenticate call.
	 */
	signInWithPhoneNumber(phoneNumber: string, recaptchaVerifier: RecaptchaVerifier): Promise<boolean> {
		return new Promise<any>((resolve, reject) => {
			signInWithPhoneNumber(getAuth(), phoneNumber, recaptchaVerifier)
				.then((confirmationResult: ConfirmationResult) => {
					this.confirmationResult = confirmationResult;

					// Reset ReCaptcha?
					// this.resetRecaptcha(recaptchaVerifier);

					resolve(true);
				})
				.catch((error) => {
					// Reset ReCaptcha?
					// this.resetRecaptcha(recaptchaVerifier);

					switch (error['code']) {
						case `auth/too-many-requests`:
						case `auth/quota-exceeded`:
						case `auth/invalid-app-credential`:
						case `auth/operation-not-allowed`:
						case `auth/captcha-check-failed`:
							reject(false);

							break;
						default:
							this.snackService.open(error.message, 5000, null, 'error');
					}
				});
		});
	}

	/**
	 * Initialize the Recaptcha verifier
	 *
	 * @returns The `RecaptchaVerifier`
	 */
	initializeRecaptcha(): RecaptchaVerifier {
		const localeParam = location.pathname.split('/')[1];

		// Set Recaptcha language.
		if (localeParam) {
			getAuth().languageCode = localeParam;
		}

		const recaptchaVerifier = new RecaptchaVerifier(
			'google-recaptcha-invisible',
			{
				size: 'invisible',
			},
			getAuth()
		);

		// Render the Recaptcha.
		recaptchaVerifier.render().then((widgetId: number) => {
			// Widget id will use on reseting the Recaptcha if needed.
			window['recaptchaWidgetId'] = widgetId;
		});

		return recaptchaVerifier;
	}

	/**
	 * Verify OTP code.
	 *
	 * @param otpCode The OTP code received by SMS.
	 * @returns Firebase access token.
	 */
	sendOtpCode(otpCode: string): Promise<string> {
		return new Promise<string>((resolve, reject) => {
			this.confirmationResult
				.confirm(otpCode)
				.then((result: UserCredential) => {
					resolve(result.user['accessToken']);
				})
				.catch((error) => {
					reject(error.message);
				});
		});
	}

	/**
	 * Clear/Reset the Recaptcha verifier
	 */
	// private resetRecaptcha(recaptchaVerifier: RecaptchaVerifier): void {
	// 	if (typeof window['grecaptcha'] !== 'undefined' && typeof window['recaptchaWidgetId'] !== 'undefined') {
	// 		window['grecaptcha'].reset();
	// 		recaptchaVerifier.clear();
	// 	}
	// }

	// private onRecaptchaSuccess(): void {
	// 	// Add handling here for recaptcha success
	// }

	// private onRecaptchaError(): void {
	// 	// Add handling here for recaptcha error
	// }
}
